import { render, staticRenderFns } from "./cone.component.vue?vue&type=template&id=67490375&functional=true&"
import script from "./cone.component.vue?vue&type=script&lang=ts&"
export * from "./cone.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports